/**
 * @namespace Comment
 * @aka KINDERNETZ.Comment
 *
 */

KINDERNETZ.Comment = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'Comment';
  var DATA_KEY = 'kindernetz.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy="comment-wrapper"]'
  };

  var Default = {
    commentable: false,
  };

  var DefaultType = {
    commenturl: 'string',
    commentable: 'boolean',
    captchaurl: '(undefined|string)',
    commentpolicyurl: 'string',
    privacyurl: 'string'
  };

  function convertTime(timestamp, readable){
    if(undefined === readable) {
      readable = true;
    }

    var fillZeros = function(item) {
      return (item < 10 ? '0' : '') + item;
    };

    var a = new Date(timestamp);
    if(readable) {
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      return a.getFullYear() + '-' + months[a.getMonth()] + '-' + fillZeros(a.getDate()) + ' ' + a.getHours() + ':' + fillZeros(a.getMinutes()) + ':' + fillZeros(a.getSeconds());
    } else {
      return a.getFullYear() + '-' + fillZeros(a.getMonth()) + '-' + fillZeros(a.getDate()) + 'T' + a.getHours() + ':' + fillZeros(a.getMinutes()) + ':' + fillZeros(a.getSeconds()) + '+00:00';
    }
  }

  function convertTimeRelative(timestamp) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;

    var elapsed = Date.now() - new Date(timestamp);

    if(elapsed < msPerMinute) {
      return 'vor ' + Math.round(elapsed / 1000) + ' Sekunden';
    } else if(elapsed < msPerHour) {
      if(1 < Math.round(elapsed / msPerMinute)) {
        return 'vor ' + Math.round(elapsed / msPerMinute) + ' Minuten';
      } else {
        return 'vor ' + Math.round(elapsed / msPerMinute) + ' Minute';
      }
    } else if(elapsed < msPerDay) {
      if(1 < Math.round(elapsed / msPerHour)) {
        return 'vor ' + Math.round(elapsed / msPerHour) + ' Stunden';
      } else {
        return 'vor ' + Math.round(elapsed / msPerHour) + ' Stunde';
      }
    } else if(elapsed < msPerMonth) {
      if(1 < Math.round(elapsed / msPerDay)) {
        return 'vor ' + Math.round(elapsed / msPerDay) + ' Tagen';
      } else {
        return 'vor ' + Math.round(elapsed / msPerDay) + ' Tag';
      }
    } else if(elapsed < msPerYear) {
      if(1 < Math.round(elapsed / msPerMonth)) {
        return 'vor ' + Math.round(elapsed / msPerMonth) + ' Monaten';
      } else {
        return 'vor ' + Math.round(elapsed / msPerMonth) + ' Monat';
      }
    } else {
      if(1 < Math.round(elapsed / msPerYear)) {
        return 'vor ' + Math.round(elapsed / msPerYear) + ' Jahren';
      } else {
        return 'vor ' + Math.round(elapsed / msPerYear) + ' Jahr';
      }
    }
  }

  function addButton(element, max_line){
    var $this = $(element);
    var lineheight = parseInt($this.css('line-height'), 10);
    if(($this.height() / lineheight) > max_line) {
      // when the current item has too much text, add a read more button and the logic
      $this.css('height', lineheight * max_line + 'px');
      $this.addClass('readmore');

      var button = $('<button class="readmore-toggle" title="Kommentar vollständig anzeigen">...</button>');
      $(button).on('click', function() {
        $('.readmore', this.parentNode).css('height', 'auto');
        $(this).hide();
      });

      $(element.parentNode).append(button);
    }
  }

  /**
   * Checks if the existing comments should be minified and adds a readmore toggle and the respective event logic
   */
  function hideText(replies) {
    var max_line = 4;

    if(replies) {
      $('.comment-replies').find('.comment-content').find('p:not(.readmore)').each(function () {
        addButton(this, max_line)
      });
    }else {
      $('.comment').find('.comment-content').find('p:not(.readmore)').each(function() {
        addButton(this, max_line)
      });
    }

  }

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Comment = function () {

    var maxlength = 900;

    var templateContainer = '' +
      '<section ' +
      '  id="comments-{id}" ' +
      '  data-spy="comments" ' +
      '  data-ref="article-{id}" ' +
      '  data-url="{canonicalUrl}" ' +
      '  data-title="{documentTitle}" ' +
      '  data-start="2016-09-15T00:00" ' +
      '  data-end="2016-10-15T00:00">' +
      '  <h2>Kommentare ({count})<button id="showcomments" class=""><span class="sr-only">zeige Kommentare</span></button></h2>' +
      '  <div class="comments-meta">' +
      '    <dl>' +
      '      <dt class="comments-quantity">Bisherige Kommentare</dt>' +
      '      <dd class="comments-quantity">{count}</dd>' +
      '    </dl>' +
      '  </div>' +
      '  <div class="comments-intro">' +
      '    <h3>Wir freuen uns, dass du mit uns und anderen Nutzerinnen und Nutzern über dieses Thema diskutieren möchtest.</h3>' +
      '    <p>In den Kanälen des SWR Kindernetz kannst du dich mit anderen austauschen. Wir wünschen uns, dass dabei alle Spaß und Freude haben können. Deshalb beachte bitte unsere <a href="{policy}">Netiquette</a>.</p>' +
      '  </div>' +
      '  <ol class="comments-list">' +
      '  </ol>' +
      '</section>';

    var templateForm = '' +
      '<form class="form form-comments" action="{postUrl}" method="POST" style="display: none;">' +
      '  <div class="form-group" data-required="true">\n' +
      '    <label for="name-{id}">Dein Name<span class="required"> *</span></label>' +
      '    <input class="form-control" type="text" id="name-{id}" name="name" aria-invalid="false" value="" required>' +
      '  </div>' +
      '  <div class="form-group" data-required="true">' +
      '    <label for="comment-{id}">Dein Kommentar<span class="required"> *</span></label>' +
      '    <textarea class="form-control" name="comment" rows="10" cols="40" id="comment-{id}" maxlength="' + maxlength + '" required></textarea>' +
      '    <p class="help-block"><span>' + maxlength + '</span><span> verfügbare Zeichen</span></p>' +
      '  </div>' +
      '  <div class="checkbox" data-required="true">' +
      '    <label for="accept-privacy-{id}">' +
      '       <input type="checkbox" id="accept-privacy-{id}" name="accept" aria-invalid="false" required style="height: 0;">' +
      '       <span class="form-control-indicator"></span>' +
      '       Ich akzeptiere die Datenschutzerklärung' +
      '       <span class="required"> *</span>' +
      '    </label>' +
      '    <p class="help-block"><a href="{privacyUrl}" target="_blank" class="link link-inline inline-link">Zur Datenschutzerklärung</a></p>' +
      '  </div>' +
      '  <div class="form-group">' +
      '    <div class="form-error"></div>' +
      '  </div>' +
      '  <button class="btn btn-primary">Kommentieren</button>' +
      '</form>';

    var templateCaptcha = '' +
      '<div class="form-group" data-required="true">' +
      '  <label for="captchaAnswer">{question}<span class="required"> *</span></label>' +
      '  <input id="captchaAnswer" name="captchaAnswer" type="text" placeholder="Bitte beantworte die Frage" required/>' +
      '  <input id="captchaIndex" name="captchaIndex" type="hidden" value="{id}">' +
      '  <p class="help-block">Sicherheitsfrage</p>' +
      '</div>';

    //FriendlyCaptcha
    var templateFriendlyCaptcha = '' +
      '<div data-spy="friendlycaptcha"></div>';

    var templateCommentHeadline = '<h3 itemprop="name" tabindex="0">{headline}</h3>';

    var templateCommentReplyBtn = '' +
      '<li>' +
      '  <button class="comment-reply" data-spy="comment-reply" data-ref="comment-{id}">Antworten</button>' +
      '</li>';

    var templateCommentShowAnswersBtn = '' +
      '<li>' +
      '  <button class="comment-reply-show" data-spy="comment-reply-show" data-ref="comment-{id}">{count} Antworten <span class="verb">anzeigen</span></button>' +
      '</li>';

    var templateCommentReplies = '<ol class="comments-list comment-replies" style="display: none;"></ol>';

    var templateCommentItem = '' +
      '<li class="comment usertype-{type}">' +
      '  <article itemprop="comment" id="comment-{id}" itemscope itemtype="https://schema.org/UserComments">' +
      '    <header class="comment-header">' +
      '     {headline}' +
      '      <dl>' +
      '        <dt class="comment-creator">Kommentar von</dt>' +
      '        <dd class="comment-creator" itemprop="creator" itemscope itemtype="https://schema.org/Person">' +
      '          <span itemprop="name" itemprop="name">{username}</span></dd>' +
      '        <dt class="comment-time">Verfasst am</dt>' +
      '        <dd class="comment-time">' +
      '          <time itemprop="commentTime" datetime="{datetime}">{relativedatetime}</time>' +
      '        </dd>' +
      '      </dl>' +
      '      <span itemprop="discusses" itemscope itemtype="https://schema.org/CreativeWork">' +
      '        <link itemprop="url" href="{canonicalUrl}">' +
      '      </span>' +
      '    </header>' +
      '    <div class="comment-content">' +
      '      <div itemprop="commentText">' +
      '        <p class="">{content}</p>' +
      '      </div>' +
      '      <ul class="comment-actions">' +
      '        {commentReplyBtn}' +
      '        {commentshowAnswers}' +
      '    </ul>' +
      '  </article>' +
      '  {commentReplies}' +
      '</li>';

    var templateCommentMoreComments = '' +
      '<ul class="comment-list-actions">' +
      '    <li>' +
      '        <button class="comments-more" data-spy="comments-more" data-ref="comment-{id}">Weitere Kommentare anzeigen</button>' +
      '    </li>' +
      '</ul>';

    var templateCommentPrevComments = '' +
      '<ul class="comment-list-actions">' +
      '    <li>' +
      '        <button class="comments-less" data-spy="comments-less" data-ref="comment-{id}">Vorherige Kommentare anzeigen</button>' +
      '    </li>' +
      '</ul>';

    var templateSendError = '' +
      '<div class="alert alert-danger">' +
      '  <h2>{message}</h2>' +
      '  <p>Bitte kontaktiere uns oder lade die Seite neu und versuche es erneut.</p>' +
      '</div>';

    var moreComments = false;
    var prevComments = false;

    function Comment(element, config) {
      COMMON.Utils._classCallCheck(this, Comment);

      var self = this;
      console.log("Comments on page");
      //console.log(this);

      self.config = self._getConfig(config);
      self.element = element;

      self.useOldCaptcha = ('undefined' !== typeof self.config.captchaurl);

      self.canonicalUrl = '';
      if($('link[rel=canonical]').first().attr('href') !== undefined){
        self.canonicalUrl = $('link[rel=canonical]').first().attr('href');
      }

      self._createComments();
    }

    Comment.prototype._createComments = function _createComments() {
      var self = this;

      $.get(self.config.commenturl).done(function(data) {
        self.postUrl = data.postURL;

        // extract article id and add it to the response array
        self.externalId = data.externalId;

        self._ux(data);

        //Check the maxlength of the comment-text:
        $('textarea').on('keyup change', function (event) {
          $('.form-group-description span:first-child', event.target.parentNode).text(maxlength - $(event.target).val().length);
        });

      }).fail(function(jqXHR, textStatus, errorThrown ) {
        console.debug("Couldn't fetch comments: ", errorThrown )
      });
    };

    // private
    Comment.prototype._ux = function _ux(data) {
      var self = this;
      var $element = $(self.element);

      var parsedURL = COMMON.Utils.parseUrl(self.config.commenturl);

      var idStart = parsedURL.file.indexOf(',') + 1;
      var idLength = parsedURL.file.indexOf('~') - idStart;

      // extract article id and add it to the response array
      self.id = parsedURL.file.substr(idStart, idLength);
      self.postURL = data.postURL;

      //console.log(data);
      //console.log($element);

      //Kommentarliste erstellen:
      if (!moreComments && !prevComments) {

        self.container = $element.append(COMMON.Utils.template(templateContainer, {
          id: self.id,
          count: data.commentsAmount,
          canonicalUrl: self.canonicalUrl,
          documentTitle: document.title,
          policy: self.config.commentpolicyurl
        }));
      }

      if (0 < data.commentsAmount) {
        self._buildCommentsList($element.find('.comments-list'), data.data);
        hideText();

        //Vorherige Kommentare
        if (undefined !== data.links['prev']) {
          //console.log(data.links['prev']);
          $element.find('.comments-list').append(COMMON.Utils.template(templateCommentPrevComments, {
            id: self.id
          }));
          $('.comment-list-actions').show();

          $('.comments-less').on('click', function () {
            //console.log(self);
            self.config.commenturl = data.links['prev'];
            prevComments = true;
            $('.comment-list-actions').remove();
            var $ol = $('ol.comments-list');
            $ol.empty();
            self._createComments();
            hideText();
            $('html, body').animate({scrollTop: ($ol.first().offset().top)}, 'slow');
          });
        } else {
          prevComments = false;
        }

        //Weitere Kommentare
        if (undefined !== data.links['next']) {
          //console.log(data.links['next']);
          $element.find('.comments-list').append(COMMON.Utils.template(templateCommentMoreComments, {
            id: self.id
          }));
          $('.comment-list-actions').show();

          $('.comments-more').on('click', function () {
            //console.log(self);
            self.config.commenturl = data.links['next'];
            moreComments = true;
            $('.comment-list-actions').remove();
            var $ol = $('ol.comments-list');
            $ol.empty();
            self._createComments();
            hideText();
            $('html, body').animate({scrollTop: ($ol.first().offset().top)}, 'slow');
          });
        } else {
          moreComments = false;
        }
      }

      //Kommentare ein- und ausblenden:
      $('#showcomments').on('click', function () {
        $('html, body').animate({scrollTop: ($(this).offset().top)}, 'slow');
        if (this.className === "open") {
          //Kommentare schliessen
          this.className = "";
          $('.comments-intro').slideUp();
          $('.form-comments').slideUp();
          $('.comments-list').slideUp();
        } else {
          //Kommentare öffnen
          this.className = "open";
          $('.comments-intro').slideDown();
          $('.form-comments').slideDown();
          $('.comments-list').slideDown();
          $('.comment-replies').hide();
          hideText();
        }
      });

      //Zeigen und Verbergen der Antworten:
      $('.comment-reply-show').on('click', function () {
        if(this.lastElementChild.innerText === "anzeigen"){
          this.lastElementChild.innerText = "verbergen";
          $(this.offsetParent).find('.comment-list-actions').remove();
          $(this.offsetParent.lastElementChild).slideDown();
          hideText("replies");
        }else{
          this.lastElementChild.innerText = "anzeigen";
          $(this.offsetParent.lastElementChild).slideUp();
        }
      });

      if(!self.config.commentable) {
        //Wenn keine Kommentare mehr zugelassen sind:
        console.log("Not commentable");
        $('.comments-intro').empty().append('<h3>Die Kommentarfunktion zu dieser Seite wurde geschlossen.</h3>');
      }else {
        //Wenn Kommentare zugelassen sind, soll ein Formular erstellt werden:
        console.log("Commentable");
        self._buildForm($element);
      }
    };

    /**
     * Builds the form:
     * */
    Comment.prototype._buildForm = function _buildForm($element, commentid) {
      var self = this;
      var form;
      var $form;

      var formHTML = COMMON.Utils.template(templateForm, {
        id: (commentid) ? self.id + '_' + commentid : self.id,
        postUrl: self.postURL,
        privacyUrl: self.config.privacyurl
      });

      if (commentid) {
        //Form for answering a comment:
        form = $element.append($(formHTML));
        $form = $(form[0].lastElementChild);
        $form.addClass('form-reply');
        $form.attr('data-ref', 'comment-' + commentid);
        $form.show();
      }else {
        //Form for commenting:
        form = $('.comments-intro').after($(formHTML));
        $form = $(form[0].nextSibling);
      }

      if (!self.useOldCaptcha) {
        $element.find('form .form-error').before(COMMON.Utils.template(templateFriendlyCaptcha, {}));
        var $captcha = $element.find('[data-spy=friendlycaptcha]');
        $captcha.friendlycaptcha();
      } else {
        // async loading of captcha information needs to be timed with the built of the html
        $element.on('kindernetz:captcha:loaded', function () {
          // only valid one time
          $element.off('kindernetz:captcha:loaded');

          if (KINDERNETZ.Captcha.active) {
            $element.find('form .form-error').before(COMMON.Utils.template(templateCaptcha, {
              id: KINDERNETZ.Captcha.id,
              question: KINDERNETZ.Captcha.question()
            }));
          }
        });

        KINDERNETZ.Captcha.init($element);

        $element.on('kindernetz:captcha:loadingerror', function () {
          $element.off('kindernetz:captcha:loadingerror');
          $element.find('form').replaceWith('<div class="alert alert-danger" style="display: none;">' +
            '  <h2>Interner Fehler</h2>' +
            '  <p>Beim Laden des Formulars ist ein internen Fehler aufgetreten. Bitte kontaktiere uns oder lade die Seite neu und versuche es erneut.</p>' +
            '</div>');
        });
      }

      self._bindSendCommentEvents.call(self, $form, commentid);

      return $form;
    };

    Comment.prototype._resetForm = function _resetForm($form) {
      $form.find('.form-error').empty();
      $form.find('.form-group-description span:first-child').text(maxlength);
      $form[0].reset();

      try {
        $form.find('[data-spy=friendlycaptcha]').friendlycaptcha('reset');
      } catch (exception) {
        /* noop */
      }
    };

    Comment.prototype._buildCommentsList = function _buildCommentsList($element, data) {
      var self = this;
      //console.log(data);

      data.forEach( function(comment) {
        var commentid = self.id + comment['id'];
        var isReplyable = ('undefined' !== typeof comment['responses']);
        var replyBtn = '';
        var showAnswers = '';

        if (isReplyable && self.config.commentable) {
          replyBtn = COMMON.Utils.template(templateCommentReplyBtn, {
            id: commentid
          });
        }

        if (isReplyable && 0 < comment['responses'].length) {
          var repliesList = self._buildCommentsList( $(templateCommentReplies), comment['responses'] );
        }

        if ('undefined' !== typeof repliesList) {
          showAnswers = COMMON.Utils.template(templateCommentShowAnswersBtn, {
            id: commentid,
            count: comment['responses'].length
          });
        }

        var commentListHTML = COMMON.Utils.template(templateCommentItem, {
          type: comment['type'].toLowerCase(),
          id: commentid,
          username: comment['username'],
          headline: comment['headline'] ? COMMON.Utils.template(templateCommentHeadline, {headline: comment['headline']}) : '',
          datetime: convertTime(comment['timestamp'], false),
          relativedatetime: convertTimeRelative(comment['timestamp']),
          canonicalUrl: self.canonicalUrl,
          content: comment['content'],
          commentReplyBtn: replyBtn,
          commentshowAnswers: showAnswers,
          commentReplies: 'undefined' !== typeof repliesList ? $("<div />").append($(repliesList).clone()).html()  : ''
        });

        var $comment = $(commentListHTML).appendTo($element);

        if (isReplyable && self.config.commentable) {
          $('[data-spy="comment-reply"]', $comment).on('click', function (event) {
            var $commentContent = $comment.find('#comment-' + commentid + ' .comment-content');
            if ($commentContent.length > 0) {
              var $form = self._buildForm($commentContent, commentid);
              $form.find('button').text('Antworten');
            }
            $comment.find('.comment-reply').attr('disabled', 'true');
          });
        }
      });

      return $element[0];
    };


    Comment.prototype._bindSendCommentEvents = function _bindSendCommentEvents($form, commentid) {
      var self = this;

      $form.on('submit', _handleFormSubmit);

      $form.on('kindernetz:comments:sendbegin', _handleFormSendBegin);
      $form.on('kindernetz:comments:sendsuccess', _handleFormSuccess);
      $form.on('kindernetz:comments:sendsuccess:close', _handleFormSuccessClose);
      $form.on('kindernetz:comments:senderror', _handleFormError);

      /**
       *
       * @param event
       * @private
       */
      function _handleFormSubmit(event) {
        // preventing form submit
        event.preventDefault();
        event.stopPropagation();

        //Remove Validation-Error:
        $form.find('.has-error,.form-group-error').removeClass('has-error form-group-error');
        $form.find('.form-error').remove();

        $form.trigger('kindernetz:comments:sendbegin');

        var name = $('[name="name"]', $form).val();
        var comment = $('[name="comment"]', $form).val();

        var data = {
          username: name,
          headline: "   ",
          commenttype: "GUEST",
          content: comment,
        };

        if (!self.useOldCaptcha) {
          data['frc-captcha-solution'] = $('[name=frc-captcha-solution]', $form).val();
        } else {
          data['captchaIndex'] = $('[name=captchaIndex]', $form).val();
          data['captchaAnswer'] = $('[name=captchaAnswer]', $form).val();
        }

        // when sending a reply comment
        if('undefined' !== typeof commentid) {
          data.parentid = commentid;
        }

        $.post(self.postURL, data).done(function(data) {
          $form.trigger('kindernetz:comments:sendsuccess', [{commentid: commentid}]);
          self._resetForm($form);
        }).fail(function(jqXHR, textStatus, errorThrown) {

          try {
            $form.find('[data-spy=friendlycaptcha]').friendlycaptcha('reset');
          } catch (exception) {
            /* noop */
          }

          var msg = '';

          switch(jqXHR.status) {
            case 400:
              // captcha (above) and form submission
              $(self.element).trigger('kindernetz:comment:send-error');

              $.each(jqXHR.responseJSON.errorMessages, function (name, message) {
                var $formGroup = $form.find('[name="' + name + '"]').closest('.form-group');
                $formGroup.addClass('has-error form-group-error');
                $formGroup.append(COMMON.Utils.template('<p class="form-error">{text}</p>', {
                  text: message
                }));
              });
              return;
            case 406:
              msg = "Interner Fehler";
              $form.off('kindernetz:comments:sendbegin');
              $(self.element).trigger('kindernetz:comment:send-error');
              break;
            case 500:
              msg = "Interner Fehler";
              $form.off('kindernetz:comments:sendbegin');
              $(self.element).trigger('kindernetz:comment:send-error');
              break;
            default:
              $form.off('kindernetz:comments:sendbegin');
              msg = "Unbekannter interner Fehler";
              $(self.element).trigger('kindernetz:comment:send-error');
              break;
          }

          //Show Error:
          if(msg !== '') {
            $(self.element).find('form').replaceWith(COMMON.Utils.template(templateSendError, {
              message: msg
            }));
            $('html, body').animate({scrollTop: ($(self.element).find('.form').offset().top) - 30}, 'slow');
          }
        });
      }

      function _handleFormSendBegin(event) {
        console.debug('Kommentar wird versandt...');
      }

      function _handleFormSuccess(event, data) {
        var $element = $(self.element);
        var modalHeader = COMMON.Utils.modalHeader('');
        var modalBody = COMMON.Utils.modalBody(
          '' +
          '<div class="alert alert-success">' +
          '  <h2>Erfolgreich versendet</h2>' +
          '  <p>Danke für deinen Kommentar. Er wird von der Redaktion geprüft und in Kürze freigeschaltet.</p>' +
          '</div>'
        );

        var $modal = $(COMMON.Utils.modalDialog('modal modal-kindernetz', modalHeader, modalBody, ''));

        $modal.find('[data-dismiss]').on('click', function (event) {
          $(document).trigger('kindernetz:pixel:click', {
            category: 'CTA',
            action: 'close',
            title: COMMON.Pixel.toAtiString('Kommentar versandt')
          });

          $form.trigger('kindernetz:comments:sendsuccess:close');
        });

        $modal.appendTo('[data-spy="comments"]');
        $modal.modal({
          focus: false
        });

        $modal.on('hidden.bs.modal', function () {
          $(this).remove();
        });

        if ('undefined' !== typeof data.commentid) {
          $element.find('button[data-ref="comment-' + data.commentid + '"]').show();
          $element.find('form[data-ref="comment-' + data.commentid + '"]').remove();
        }
      }

      function _handleFormSuccessClose(event) {
        console.debug('Kommentar wurde erfolgreich versandt');
      }

      function _handleFormError(event) {
        console.debug('Beim Versenden des Kommentars ist ein Fehler aufgetreten');
      }
    };

    // public
    Comment.prototype.dispose = function dispose() {
      $(window).off(EVENT_KEY);
      $(this.element).off(EVENT_KEY);
      this.element = null;
    };

    // private
    Comment.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    // static
    Comment._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = $.extend({}, Default, $(this).data());

        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
          $.extend(_config, config);
        }

        if (!data) {
          data = new Comment(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof action === "string") {
          if (data[action] === undefined) {
            throw new Error('No method named "' + action + '"');
          }
          data[action]();
        }
      });
    };

    return Comment;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */

  $(Selector.DATA_SPY).each(function () {
    var $Comment = $(this);
    Comment._jQueryInterface.call($Comment);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $Comment = $(this);
      Comment._jQueryInterface.call($Comment);
    })
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Comment._jQueryInterface;
  $.fn[NAME].Constructor = Comment;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Comment._jQueryInterface;
  };

  return Comment;

})(window.jQuery);
